// Belgische landsgrens voor de bewonersbrief-kaart: startweergave en de
// controle dat een selectie (minstens deels) in België ligt. Vereenvoudigde
// omtrek (circa 300 m) uit geolinq:be_country, zodat de check in de browser
// zonder netwerk kan.
import GeoJSON from 'ol/format/GeoJSON';
import { fromCircle } from 'ol/geom/Polygon';
import outline from './belgium-outline.json';

const belgium = new GeoJSON().readGeometry(outline, {
  dataProjection: 'EPSG:4326',
  featureProjection: 'EPSG:3857',
});

/** Omhullende van België in EPSG:3857. */
export const BELGIUM_EXTENT = belgium.getExtent();

// Alleen de buitenringen: genoeg om te zien of een vorm een stuk grens omsluit.
const belgiumVertices = belgium.getCoordinates().flatMap((polygon) => polygon[0]);

/** Ligt een kaartcoördinaat (EPSG:3857) in België? */
export function isInBelgium(coordinate) {
  return Array.isArray(coordinate) && belgium.intersectsCoordinate(coordinate);
}

function asPolygon(geometry) {
  if (!geometry) return null;
  return geometry.getType() === 'Circle' ? fromCircle(geometry, 64) : geometry;
}

function verticesOf(polygon) {
  const type = polygon.getType();
  if (type === 'Polygon') return polygon.getCoordinates().flat();
  if (type === 'MultiPolygon') return polygon.getCoordinates().flat(2);
  return [];
}

/**
 * 'inside'  : het hele gebied ligt in België
 * 'partial' : een deel ligt over de grens
 * 'outside' : niets van het gebied ligt in België
 */
export function belgiumCoverage(geometry) {
  const polygon = asPolygon(geometry);
  if (!polygon || !polygon.intersectsExtent(BELGIUM_EXTENT)) return 'outside';

  const vertices = verticesOf(polygon);
  const insideCount = vertices.filter((c) => belgium.intersectsCoordinate(c)).length;
  const enclosesBorder = belgiumVertices.some((c) => polygon.intersectsCoordinate(c));

  if (vertices.length && insideCount === vertices.length) {
    return enclosesBorder ? 'partial' : 'inside';
  }
  if (insideCount > 0 || enclosesBorder) return 'partial';
  return 'outside';
}
